// @ts-nocheck
import { useTranslation } from "react-i18next";
import { Dropdown, message, Select, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import { useState } from "react";

export default function C2CTk({
  currencylist,
  num,
  setNum,
  currencyId,
  setcurrencyId,
  bankType,
  setbankType,
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  
  const getArray = () => {
    const array = [];
    let i = 0;
    for (const currency of currencylist) {
      array.push({
        value: currency.id,
        label: lan == "zh" ? currency.name : currency.currency,
      });
    }
    return array;
  };

  const bankTypeArray = [
    {
      value: 1,
      label: "Visa, Mastercard and JCB",
    },
    {
      value: 4,
      label: "Bank Card",
    },
    {
      value: 2,
      label: "Revolut",
    },
    {
      value: 3,
      label: "Wise",
    },{
      value: 5,
      label: "Remitly",
    },
  ];

  return (
    <div className="p-4 bg-neutral-800 rounded-lg text-neutral-200">
      {/* <Select
        style={{ width: "100%", height: "50px" }}
        placeholder={translate(getText("请选择货币"))}
        options={getArray()}
        dropdownStyle={{ zIndex: 9999, maxHeight: 200 }}
        onChange={(val) => {
          setcurrencyId(val);
        }}
      /> */}
      <Select
        style={{ 
          width: "100%", 
          height: "50px", 
          marginTop: 15,
          backgroundColor: "#1E293B",
          borderColor: "#475569",
          color: "#F8FAFC" 
        }}
        placeholder={translate(getText("请选择银行卡类型"))}
        options={bankTypeArray}
        dropdownStyle={{ zIndex: 9999, backgroundColor: "#1E293B", color: "#F8FAFC" }}
        onChange={(val) => {
          setbankType(val);
        }}
        className="custom-dark-select"
      />
      
      <div className="mt-6 p-4 bg-neutral-700/30 rounded-lg text-sm text-neutral-300 leading-relaxed">
        {translate(
          getText(
            "您的C2C交易由系統自動匹配商家，由於國際銀行匯款延時，您的貨幣交易可能會有延遲到賬，虛擬貨幣兌換法幣是按照國際實時匯率進行交易，並且請您正確輸入自己的銀行卡信息"
          )
        )}
      </div>
      
      <div className="mt-4 p-3 bg-primary/10 border border-primary/20 rounded-lg text-sm text-primary-light">
        {translate(
          getText(
            "請先選擇貨幣，點擊確定表明您已經同意並且閱讀上方提示信息，否則請點取消"
          )
        )}
      </div>
      
      <style jsx global>{`
        .custom-dark-select .ant-select-selector {
          background-color: #1E293B !important;
          border-color: #475569 !important;
          color: #F8FAFC !important;
        }
        .custom-dark-select .ant-select-arrow {
          color: #8B5CF6 !important;
        }
        .ant-select-dropdown {
          background-color: #1E293B !important;
        }
        .ant-select-item {
          color: #F8FAFC !important;
        }
        .ant-select-item-option-selected {
          background-color: #374151 !important;
        }
        .ant-select-item-option-active {
          background-color: #374151 !important;
        }
      `}</style>
    </div>
  );
}
